import IconButton from '@mui/material/IconButton';
import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AgyleAddTaskIcon, AgyleIceDocumentIcon } from '../icons/agyle';
import makeStyles from '@mui/styles/makeStyles';
import PatientAlarmsButton from './components/patientAlarmsButton';
import PatientFlagsButton from './components/patientFlagsButton';
import PatientAddNoteButton from './components/patientAddNoteButton';
import SmartSearchButton from '../search/smartSearchButton';
import ActionPanelButton from '../actionPanel/actionPanelButton';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    iconBackground: {
        backgroundColor: theme.palette.background.dialogBorder,
        borderRadius: 6,
    },
}));

const PatientHeaderAdditionalButtons = ({ patient, handleSaveData, disableSave, pastAttendances }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const isLong = useMediaQuery('(min-width:1560px)');

    return (
        <div className={classes.root}>
            <PatientAddNoteButton patient={patient} disableSave={disableSave} pastAttendances={pastAttendances} />

            {/* Deactivated for now */}
            {isLong && false && (
                <>
                    <Tooltip title={t('Add task')}>
                        <IconButton onClick={() => alert('TODO Add Task')} className={classes.iconBackground} size="small">
                            <AgyleAddTaskIcon />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={t('ICE')}>
                        <IconButton onClick={() => alert('TODO Ice third party system')} className={classes.iconBackground} size="small">
                            <AgyleIceDocumentIcon />
                        </IconButton>
                    </Tooltip>
                </>
            )}

            {patient?.patient?.activeAttendances?.length > 0 && (
                <PatientFlagsButton patient={patient} disableSave={disableSave} handleSaveData={handleSaveData} />
            )}

            <PatientAlarmsButton patient={patient} disableSave={disableSave} />

            <SmartSearchButton />

            <ActionPanelButton />
        </div>
    );
};

export default PatientHeaderAdditionalButtons;
